import React from 'react';
import {
  IconUiHome,
  IconUiBusinessCardType,
  IconUiTickCircle,
  IconUiTag,
  IconUiOrderHistory,
  IconUiPeople,
  IconUiHelpCircle,
  IconUiSettings,
} from 'moods-react/Icons';
import BulkEditIcon from '../common/icons/bulkEdit/BulkEditComponent';
import FlagUK from '../common/icons/flags/uk/FlagUKComponent';
import FlagUS from '../common/icons/flags/us/FlagUSComponent';
import FlagAU from '../common/icons/flags/au/FlagAUComponent';
import FlagCA from '../common/icons/flags/ca/FlagCAComponent';
import FlagEU from '../common/icons/flags/eu/FlagEUComponent';

import {
  canAccessDashboard,
  canAccessOrderHistory,
  canManageUser,
  canBulkEditProducts,
  canOrderAccessories,
  canAccessApprovals,
} from '../services/user-permission/UserPermissionService';

import { envUrl, isProduction } from '../services/environment/EnvironmentService';

import { isAccountSettingsEnabled } from '../../clients/FeaturesClient';

const navItems = [
  {
    name: 'dashboard',
    icon: <IconUiHome />,
    isDisplayed: canAccessDashboard,
    url: envUrl('/dashboard'),
    link: true,
  },
  {
    name: 'products',
    icon: <IconUiBusinessCardType />,
    isDisplayed: () => true,
    url: envUrl('/products'),
    link: true,
  },
  {
    name: 'approvals',
    icon: <IconUiTickCircle />,
    isDisplayed: canAccessApprovals,
    url: envUrl('/approvals'),
    link: true,
  },
  {
    name: 'accessories',
    icon: <IconUiTag />,
    isDisplayed: canOrderAccessories,
    url: envUrl('/accessories'),
    link: true,
  },
  {
    name: 'orders',
    icon: <IconUiOrderHistory />,
    isDisplayed: canAccessOrderHistory,
    url: envUrl('/orders', '/m4b'),
    link: !isProduction(),
  },
  {
    name: 'people',
    icon: <IconUiPeople />,
    isDisplayed: canManageUser,
    url: envUrl('/people', '/m4b'),
    link: !isProduction(),
  },
  {
    name: 'bulkEdit',
    icon: <BulkEditIcon />,
    isDisplayed: canBulkEditProducts,
    url: envUrl('/bulk', '/m4b'),
    link: !isProduction(),
  },
  {
    name: 'help',
    icon: <IconUiHelpCircle />,
    isDisplayed: () => true,
    url: envUrl('/help'),
    link: true,
  },
  {
    name: 'settings',
    icon: <IconUiSettings />,
    isDisplayed: (props, editableAccountSettings) => {
      return editableAccountSettings && editableAccountSettings.length > 0 && isAccountSettingsEnabled();
    },
    url: envUrl('/settings'),
    link: true,
  },
];

const headerLinks = {
  account: '/m4b/account/details',
  browse: '/m4b/nav/moo-soho',
  consent: '/m4b/nav/consent/manage',
  cart: '/m4b/cart/',
  logout: '/m4b/account/logout',
};

const getNavItems = (permissions, editableAccountSettings) => {
  return navItems.filter((navItem) => navItem.isDisplayed(permissions, editableAccountSettings));
};

const getUrlFor = (name) => {
  return navItems.find((element) => element.name === name).url;
};

const getFlag = (code = 'uk') => {
  switch (code) {
    case 'uk':
      return <FlagUK />;
    case 'ca':
      return <FlagCA />;
    case 'us':
      return <FlagUS />;
    case 'au':
      return <FlagAU />;
    case 'eu':
      return <FlagEU />;
    default:
      return <FlagUK />;
  }
};

export { getFlag, getNavItems, getUrlFor, headerLinks };
